export default "__VITE_ASSET__uW8kz4aL__"